
(function () {
    "use strict";

    angular.module("app").factory("pscRequestValidation", PscRequestValidationService);

    class RangeValidationResult {

        #isValid = true;
        #isEmpty = false;
        #missingPeriods = [];

        /**
         * Default state is successful validation
         */
        constructor() { }

        /**
         * Indicates full required period of time is covered
         */
        get isValid() { return this.#isValid; }
        set isValid(isValid) { this.#isValid = isValid; }

        /**
         * Indicates no data has been entered yet.
         */
        get isEmpty() { return this.#isEmpty; }
        set isEmpty(isEmpty) { this.#isEmpty = isEmpty; }

        /**
         * Indicates the current address or occupation is not entered yet
         */
        get isCurrentMissing() { return this.#isEmpty || this.#missingPeriods.some(item => item.DateTo === null); }

        /**
         * Indicates the missing dates
         */
        get missingPeriods() { return this.#missingPeriods; }
    }

    class PartnerValidationResult {
        #isIncomplete = false;
        #addressValidation = new RangeValidationResult();

        constructor() { }

        /**
         * Partner validation is successful when the personal information is complete and their address for at least 10 years is provided
         */
        get isValid() { return !this.#isIncomplete && this.#addressValidation.isValid; }

        /**
         * Determines if the personal information of the partner is incomplete
         */
        get isIncomplete() { return this.#isIncomplete; }
        set isIncomplete(isIncomplete) { this.#isIncomplete = isIncomplete; }
        /**
         * Address validation details
         */
        get addressValidation() { return this.#addressValidation; }
        set addressValidation(addressValidation) { this.#addressValidation = addressValidation; }
    }

    PscRequestValidationService.$inject = ["$filter"];
    function PscRequestValidationService($filter) {

        const getTranslation = $filter("habilTranslation");
        const validatorCache = {};
        return {
            CreateDateRangeValidator,
            GetMissingPeriodOfTimeMessage,
            CreateRangeValidationResult,
            CreatePartnerValidationResult,
            ConvertDatePropertiesToDateObject,
        };

        function CreateDateRangeValidator(months) {

            let validator = validatorCache[months];
            if (!validator) {
                validator = new habilCommon.DateRangeValidator(habilCommon.LocalDate.now().minusMonths(months));
                validatorCache[months] = validator;
            }

            return validator;
        }

        function GetMissingPeriodOfTimeMessage(dateFrom, dateTo) {

            if (dateTo === null) {
                return getTranslation("DateRangeValidation_MissingData_Since_Format").replace("{StartDate}", dateFrom.format(habilCommon.dateFormatter));
            }

            return getTranslation("DateRangeValidation_MissingData_From_To_Format")
                .replace("{StartDate}", dateFrom.format(habilCommon.dateFormatter))
                .replace("{EndDate}", dateTo.format(habilCommon.dateFormatter));
        }

        function CreateRangeValidationResult(result) {
            const validationResult = new RangeValidationResult();

            validationResult.isValid = result.Success;
            validationResult.missingPeriods.push(...result.MissingPeriods.map(p => GetMissingPeriodOfTimeMessage(p.DateFrom, p.DateTo)));

            return validationResult;
        }

        function CreatePartnerValidationResult() {
            return new PartnerValidationResult();
        }

        function ConvertDatePropertiesToDateObject(item) {
            if (item.DateFrom && !(item.DateFrom instanceof Date))
                item.DateFrom = new Date(item.DateFrom);
            if (item.DateTo && !(item.DateTo instanceof Date))
                item.DateTo = new Date(item.DateTo);
        }
    }
})();
